module.exports = __webpack_public_path__ + "static/media/B62022 - Notice of Proposal to Refuse an Application.c6f1eb17.pdf";